import React from 'react';
import {Card, CardContent, Grid, Typography } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import Card64Image from 'components/card64Image';

const DetalleDeLaVallaMovil = ({datosDelMedioSeleccionado, datosDelQRMovil}) => {
  const classes = styles();

  const {costo, anchoValla, altoValla, descripcionRuta, dosVallasEnUnidad, unaVallaEnUnidad, imagenDeRuta, esFija, esMovil} = datosDelMedioSeleccionado;

  return (
    <Card className={classes.root}>
        <CardContent>
          <Grid container justify="space-between" alignItems="center" spacing={4} wrap={"wrap"} >
              <Grid item xs={12} md={6}>
                <TituloConIcono title={"Datos de la valla móvil"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                <ElementoDelCard title={'Nombre:'} label={datosDelQRMovil?.nombre || ""}/>
                <ElementoDelCard title={'Costo:'} label={costo}/>
                <ElementoDelCard title={'¿Es digital?:'} label={esMovil ? "SI" : "NO" || ""}/>
                <ElementoDelCard title={'¿Es física?:'} label={esFija ? "SI" : "NO" || ""}/>
                <ElementoDelCard title={'Una valla:'} label={unaVallaEnUnidad ? "SI" : "NO" || ""}/>
                <Grid item xs={12}>
                    {datosDelQRMovil?.qr ? (
                        <Card64Image
                            label={"QR"} image={datosDelQRMovil?.qr} title={"QR"} src={datosDelQRMovil?.qr} showTitle={false} showTitle2={true} documentName={datosDelQRMovil?.nombre} getDocumentOfPoliticalOrganization={undefined} showButtonEditDocument={false} handleClickUpdateDocument={undefined}
                            showInMovil={true} firstTitle={""} observacion={""} idDocumento={"idDocumento"} idEstadoDocumento={""}
                        />
                    ): <Typography variant="h5" component="div" align='center'> No hay QR</Typography>}
                  </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                  <TituloConIcono title={"Dimensiones (cm)"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                  <ElementoDelCard title={'Dos valla:'} label={dosVallasEnUnidad ? "SI" : "NO" || ""}/>
                  <ElementoDelCard title={'Valla acho:'} label={anchoValla || ""}/>
                  <ElementoDelCard title={'Valla alto:'} label={altoValla || ""}/>
                  <ElementoDelCard title={'Descripción de la ruta:'} label={descripcionRuta || ""}/>
                  <ElementoDelCard title={'Observación:'} label={datosDelQRMovil?.observacion || ""}/>
                  <Grid item xs={12} >
                  {imagenDeRuta ? (
                        <Grid item xs={12} sm={6} md={4} lg={3} >
                            <Card64Image
                                label={"LOGO"} image={imagenDeRuta} title={"Imagen de la ruta"} src={imagenDeRuta} showTitle={false} showTitle2={true} documentName={imagenDeRuta} getDocumentOfPoliticalOrganization={undefined} showButtonEditDocument={false} handleClickUpdateDocument={undefined}
                                showInMovil={true} firstTitle={""} observacion={""} idDocumento={"idDocumento"} idEstadoDocumento={""}
                            />
                        </Grid>
                    ): <Typography variant="h5" component="div" align='center'>No Adjunto imagen de la valla <br/> </Typography>}
                  </Grid>
              </Grid>
          </Grid>
        </CardContent>
    </Card>
  );
}

export default DetalleDeLaVallaMovil;